export const mmI18nKeys = {
    ConfirmDelete: "ConfirmDelete",
    OK: "OK",
    Cancel: "Cancel",
    Delete: "Delete"
}